var React = require('react');

function Leftblob (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M194.568 0.0558585C276.154 1.82928 292.571 65.7497 315.322 125.933C335.885 180.329 349.706 220.535 290.805 254.635C227.958 291.02 125.867 308.694 60.3784 275.168C-13.0178 237.593 -9.21019 175.541 17.8895 111.084C45.1352 46.2797 105.913 -1.87123 194.568 0.0558585Z","fill":"#F0EFFF"}));
}

Leftblob.defaultProps = {"width":"333","height":"293","viewBox":"0 0 333 293","fill":"none"};

module.exports = Leftblob;

Leftblob.default = Leftblob;
